// Live BOM feature is currently hidden at the wiring points
// (ProjectDesign, Engineering, Header, epics, saveProject, styles).
// Uncomment those call sites (search "LIVE BOM: temporarily hidden") to restore.
export const LIVE_BOM_AUTO_REFETCH_DEBOUNCE_MS = 0;
